import { AmaxPayFullLogo } from '@approvalmax/ui';
import { SimpleLayout } from '@approvalmax/ui/src/components';
import { Helmet } from 'react-helmet';

import { Wizard } from './resources/components';
import { messages } from './resources/messages';

const Page = () => {
    return (
        <SimpleLayout size='small' verticalAlign='start' logo={<AmaxPayFullLogo />}>
            <Helmet title={messages.title} />

            <SimpleLayout.Content>
                <Wizard />
            </SimpleLayout.Content>
        </SimpleLayout>
    );
};

Page.displayName = 'Page';

export default Page;
